import { Moment } from 'moment-timezone'
import React from 'react'
import { useTranslate } from 'src/localization/Trns'
import { RecurrenceTerminator } from 'src/models/recurrence.models'

interface RecurrenceEndingLabelProps {
  className?: string
  terminator: RecurrenceTerminator
  count?: number
  untilMoment?: Moment
}

const RecurrenceEndingLabel: React.FC<RecurrenceEndingLabelProps> = (
  props,
): React.ReactNode => {
  const translate = useTranslate()

  switch (props.terminator) {
    case RecurrenceTerminator.Count: {
      return props.count === 1
        ? translate('Ends after 1 reset')
        : translate('Ends after ${count} resets', {
            count: `${props.count}`,
          })
    }
    case RecurrenceTerminator.Date: {
      return translate('until ${date}', {
        date: props.untilMoment?.format('l') || '',
      })
    }
    case RecurrenceTerminator.None: {
      return translate('forever')
    }
    default: {
      return translate('Unknown')
    }
  }
}

export default RecurrenceEndingLabel
